import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TenantSelectionService } from '../tenancy/tenant-selection.service';

/**
 * Tells the API which company database a request is for:
 * - `X-Tenant-Host`: the host this page was opened on. Public QR pages are
 *   served on the company's own subdomain (acme.giftqr…), so the host selects
 *   the company. Ignored by the backend on authenticated routes.
 * - `X-Tenant-Id`: the company a superadmin selected (ignored for other roles).
 * Only added to requests to our API, never to third parties (S3 uploads…).
 */
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.API_DOMAIN)) {
    return next(req);
  }
  const headers: Record<string, string> = { 'X-Tenant-Host': window.location.hostname };
  const tenantId = inject(TenantSelectionService).tenantId();
  if (tenantId !== null) {
    headers['X-Tenant-Id'] = String(tenantId);
  }
  return next(req.clone({ setHeaders: headers }));
};
